import _jsx from "@babel/runtime/helpers/jsx";
var _br;
import PropTypes from 'prop-types';
import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalTitle } from 'reaxl';

/**
 * The Confirmation component will render the confirmation in an iframe if the url is passed. It will also render in a modal or static if the isModal is true
 */

function Confirmation(_ref) {
  var _Fragment;
  let {
    text,
    onHide,
    isModal,
    confirmationMessage = 'Your Email has been sent.',
    dataCmp = 'emailConfirmation',
    title = 'Email Confirmation',
    size,
    ...rest
  } = _ref;
  const getConfirmationContent = () => /*#__PURE__*/_jsx("div", {
    className: "alert alert-success"
  }, void 0, /*#__PURE__*/_jsx("div", {}, void 0, confirmationMessage && (_Fragment || (_Fragment = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx("strong", {}, void 0, confirmationMessage), _br || (_br = /*#__PURE__*/_jsx("br", {}))))), text));
  const handleHide = data => {
    if (onHide) {
      onHide(data);
    }
  };
  if (isModal) {
    const bsSize = size ? 'sm' : 'large';
    return /*#__PURE__*/React.createElement(Modal, Object.assign({
      show: true,
      onHide: handleHide,
      bsSize: bsSize
    }, rest), /*#__PURE__*/_jsx(ModalHeader, {
      closeButton: true
    }, void 0, /*#__PURE__*/_jsx(ModalTitle, {}, void 0, title)), /*#__PURE__*/_jsx(ModalBody, {
      className: "clearfix"
    }, void 0, getConfirmationContent()));
  }
  return /*#__PURE__*/React.createElement("div", Object.assign({
    "data-cmp": dataCmp
  }, rest), getConfirmationContent());
}
export default Confirmation;